import { render, staticRenderFns } from "./JournalCard.vue?vue&type=template&id=72a87578&scoped=true"
import script from "./JournalCard.vue?vue&type=script&lang=js"
export * from "./JournalCard.vue?vue&type=script&lang=js"
import style0 from "./JournalCard.vue?vue&type=style&index=0&id=72a87578&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a87578",
  null
  
)

export default component.exports